import {Observable, Subscription} from 'rxjs';

import IFrameStore from '../Interfaces/IFrameStore';

const subscribeToConsumerToggleFullscreen = (
    consumerToggleFullscreen$: Observable<boolean>,
    frameStore: IFrameStore
): Subscription =>
    consumerToggleFullscreen$
        .subscribe((shouldFullscreen: boolean) => shouldFullscreen ?
            frameStore.actions.enterFullscreen() :
            frameStore.actions.exitFullscreen()
        );

export default subscribeToConsumerToggleFullscreen;